import { useEffect } from 'react'

const useBlueBackground = () => {
  useEffect(() => {
    const body = document.getElementsByTagName('body')?.[0]
    const root = document.getElementById('root')
    body?.classList?.add('bg-primary-1')
    root?.classList?.add('bg-primary-1')
    return () => {
      body?.classList?.remove('bg-primary-1')
      root?.classList?.remove('bg-primary-1')
    }
  }, [])
}

export default useBlueBackground
